module.exports = __webpack_public_path__ + "img/but_table_confirm_bet.31d08625.png";